// extracted by mini-css-extract-plugin
export default {"input":"NewInput_input__QqhHY"};